module.exports = __webpack_public_path__ + "img/ContentBlockWithImagesAndCaptions.4db294d9.png";